import { MixDetailsPanel } from "../mixDetails/MixDetailsPanel";
import { Period } from "hooks/periodIndex";
import { ClickableChip } from "components/common/chips/clickable";
import { PlanId } from "components/common/boundary/PlanId";
import { MixPropertiesPanel } from "../mixDetails/MixPropertiesPanel";
import { useNumberQueryParamState } from "hooks/useNumberQueryParamState";

interface BaseProps {
  id: number;
  name: string;
}

interface MixDetailProps {
  planId: PlanId;
  period: Period;
  mix: number;
}

type Props = BaseProps | (BaseProps & MixDetailProps);

export const ChemistryGroupChip = ({ id, name, ...props }: Props) => {
  const [openPanel, setOpenPanel] = useNumberQueryParamState(
    "selected_chemistry_group_id",
    null
  );
  const isDetailedView =
    "planId" in props && "period" in props && "mix" in props;
  return (
    <>
      <ClickableChip
        label={name}
        onClick={() => {
          setOpenPanel(id);
        }}
      />
      {isDetailedView ? (
        <MixDetailsPanel
          mix={props.mix}
          planId={props.planId}
          period={props.period}
          group={id}
          open={openPanel === id}
          setOpen={(open) => {
            setOpenPanel(open ? id : null);
          }}
          multipleMixes={false}
        />
      ) : (
        <MixPropertiesPanel
          group={id}
          open={openPanel === id}
          setOpen={(open) => {
            setOpenPanel(open ? id : null);
          }}
        />
      )}
    </>
  );
};
